"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
require("./no-data-found.less");
const NoDataFound = (props) => (React.createElement("div", null,
    props.headerComponent,
    "No Data Found. Please select or reset your Query Options."));
exports.default = NoDataFound;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/no-data-found/no-data-found.tsx
// module id = 195
// module chunks = 0